import React from 'react';
import Classifieds from './Classifieds';
import BreadCrumb from './BreadCrumb';

function ClassifiedPage() {
    return ( 
        <div className= "container-fluid">
        <BreadCrumb />
        <Classifieds />
        
        </div>
     );
}

export default ClassifiedPage;